(($, duo) => {
  Drupal.behaviors.languageselection = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      /* setup language selection */
      /* ************************ */

      const $languageSelectionBlocks = $(context).find('.js-keolis-language-selection');
      $languageSelectionBlocks.each(function(index, element) {
        const $languageSelectionBlock = $(element);

        // get the content block (the block that should toggle):
        const $contentBlock = $languageSelectionBlock.find('.js-keolis-language-selection-content');

        // get a unique ID for the toggle:
        const langSelectId = 'lang-' + duo.Utils.uniqueId;

        // hide the content block and add unique ID:
        $contentBlock.attr('hidden', 'true');
        $contentBlock.attr('id', langSelectId);

        // set the text for the toggle button:
        let toggleButtonText = Drupal.t('Language');

        // get the current active language:
        const htmlActiveLangString = $('html').attr('lang');
        const langLinkText = htmlActiveLangString;
        toggleButtonText = langLinkText;

        // add a toggle button:
        const langToggleButton = $(`<button class="keolis-language__toggle-button js-keolis-language-toggle" aria-expanded="false" aria-controls="${ langSelectId }">
          <span>${ toggleButtonText }</span>
          <svg width="14" height="8" viewBox="0 0 14 8" aria-hidden="true" focusable="false">
            <path d="M13.1 1.9c.4-.4.4-.9 0-1.3s-.9-.4-1.3 0L7 5.4 2.2.6C1.8.2 1.3.2.9.6s-.4 1 0 1.3l5.5 5.5c.4.4.9.4 1.3 0l5.4-5.5z" />
          </svg>
        </button>`);
        $languageSelectionBlock.prepend(langToggleButton);

        // add "active" class:
        $languageSelectionBlock.addClass('js-ready');
      });

      /* language toggle events */
      /* ********************** */

      $(document).once('languageselection').on('click.languageselection', '.js-keolis-language-toggle', function() {
        const $toggleButton = $(this);
        self._toggleLanguageSelection($toggleButton);
      });

      // close all language-selections with ESC:
      $(document).on('keydown.languageselection', function(event) {
        if(event.keyCode === 27) {
          const $langToggleButtons = $(document).find('.js-keolis-language-toggle[aria-expanded="true"]');
          $langToggleButtons.each(function(index, element) {
            self._toggleLanguageSelection($(element));
          });
        }
      });

      // close language-selection with click-outside:
      $(document).on('click.languageselection', function(event) {
        const target = $(event.target);
        if(target.closest($('.js-keolis-language-toggle')).length <= 0 && target.closest($('.js-keolis-language-selection-content')).length <= 0) {
          const $langToggleButtons = $(document).find('.js-keolis-language-toggle[aria-expanded="true"]');
          $langToggleButtons.each(function(index, element) {
            self._toggleLanguageSelection($(element));
          });
        }
      });

    },

    _toggleLanguageSelection: function($toggleButton) {
      const controlledElementId = $toggleButton.attr('aria-controls');
      const $controlledElement = $(`#${controlledElementId}`);
      const state = $toggleButton.attr('aria-expanded') === 'false' ? true : false;

      // -> set the expanded state on the button:
      $toggleButton.attr('aria-expanded', state);
      // -> set hidden state on the content:
      if(state) {
        $controlledElement.removeAttr('hidden');
      } else {
        $controlledElement.attr('hidden', 'true');
      }
    }

  };
})(jQuery, window.duo = window.duo || {});
